import { KeyAndScale } from '@arpeggi/shared'
import { Box, styled, Tag } from '@arpeggi/ui'
import { FC } from 'react'
import { CloseIcon } from '../../../__legacy__/components/core/icons'
import { FILTER_TYPES } from '../../../__legacy__/components/platform/new-explore/components/TypeDropdown'
import { useArpTableContext } from './ArpTableContext'

const Close = styled(CloseIcon, { width: '12px', height: '12px' })

const GenreTags: FC = () => {
  const { filters, updateFilters } = useArpTableContext()
  const { genre } = filters
  const handleGenre = (value: string) => () => {
    updateFilters({ genre: genre.filter((v) => v !== value) })
  }
  if (!genre) return null
  return (
    <>
      {genre.map((g) => (
        <Tag key={g} onClick={handleGenre(g)} variant="success">
          {g}
          <Close />
        </Tag>
      ))}
    </>
  )
}

const InstrumentTags: FC = () => {
  const { filters, updateFilters } = useArpTableContext()
  const { tag } = filters
  const handleTag = (value: string) => () => {
    updateFilters({ tag: tag.filter((v) => v !== value) })
  }
  if (!tag) return null
  return (
    <>
      {tag.map((t) => (
        <Tag key={t} onClick={handleTag(t)} variant="success">
          {t}
          <Close />
        </Tag>
      ))}
    </>
  )
}

const TypesTags: FC = () => {
  const { filters, defaultFilters, updateFilters } = useArpTableContext()
  const { typesAndSubTypes } = filters
  const isDefaultType = typesAndSubTypes === defaultFilters.typesAndSubTypes
  const selectedTypes = FILTER_TYPES.filter((type) => typesAndSubTypes.includes(type.value)).map(
    (type) => type.label
  )
  const handleTypes = () => {
    updateFilters({ typesAndSubTypes: defaultFilters.typesAndSubTypes })
  }
  if (isDefaultType) return null
  return (
    <Tag onClick={handleTypes} variant="success">
      {selectedTypes.join(', ')}
      <Close />
    </Tag>
  )
}

const KeyTags: FC = () => {
  const { filters, defaultFilters, updateFilters } = useArpTableContext()
  const { key } = filters
  const isDefaultKey = key === defaultFilters.key
  const handleKey = () => {
    updateFilters({ key: defaultFilters.key })
  }
  if (isDefaultKey) return null
  return (
    <Tag onClick={handleKey} variant="success">
      {KeyAndScale.from(key).displayName()}
      <Close />
    </Tag>
  )
}

export const Tags: FC = () => {
  return (
    <Box row alignCenter css={{ gap: '4px' }}>
      <GenreTags />
      <InstrumentTags />
      <KeyTags />
      <TypesTags />
    </Box>
  )
}
